module.exports = __webpack_public_path__ + "img/loan-hiw-image.e11ee3a5.png";